if (!theme.fetchCache) {
  theme.fetchCache = {
    responses: new Map(),

    fetch(url) {
      if (!this.responses.has(url)) {
        const request = fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
          })
          .catch((error) => {
            this.responses.delete(url);
            throw error;
          });
        this.responses.set(url, request);
      }
      return this.responses.get(url);
    },

    preload(url) {
      return this.fetch(url).catch(() => undefined);
    },

    clear() {
      this.responses.clear();
    }
  };
}
